import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import ScriptAutoTable from './scriptAutoTable';

const ScriptAutomation = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#000)] flex-1">
        <Header title="Script Center" dropdown={2} />

        <Card className="flex-1 h-full" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <ScriptAutoTable />
        </Card>
      </div>
    </div>
  );
};

export default ScriptAutomation;
